import { useIntl } from 'react-intl'
import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MegaMenu } from './MegaMenu'
import { useAuth } from 'src/app/modules/auth';
import { FILE_URL } from '../../../../../utils/baseAPI';

export function MenuInner() {

  const { currentUser, logout } = useAuth();
  const permissions = currentUser?.permissions?.join("##")

  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />

      {permissions?.includes("Manage") && (
        <>
          <MenuItem title='Quản trị' to='/admin' />
          <MenuItem title='Hướng dẫn' to='' onClick={()=>{
             window.location.href = (FILE_URL + "/Files/TaiLieuHuongDan/HDSD_PM QL Hồ sơ tài liệu.docx")
          }} />
        </>

      )}

    </>
  )
}
